import { useLanguage } from "../i18n/LanguageContext";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_NUMBER, INSTAGRAM_URL, FACEBOOK_URL, EMAIL } from "../content/siteContent";
import { IconPin, IconPhone, IconWhatsApp, IconInstagram, IconFacebook, IconMail } from "./Icons";

const SiteFooter = () => {
    const { t } = useLanguage();
    const year = new Date().getFullYear();
    return (
        <footer className="bg-pine-900 text-cream" data-testid="site-footer">
            <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 md:py-20 lg:grid-cols-4 lg:px-8">
                <div className="lg:col-span-2">
                    <div className="flex items-center gap-3">
                        <img src="/assets/thera-symbol-gold.png" alt="" className="h-11 w-11 object-contain" />
                        <span className="leading-tight">
                            <span className="block font-display text-xl font-semibold">{t.brand}</span>
                            <span className="block text-[10px] font-semibold uppercase tracking-[0.24em] text-gold-500">{t.brandLatin}</span>
                        </span>
                    </div>
                    <p className="mt-5 max-w-md text-sm leading-relaxed text-cream/70">{t.brandFull}</p>
                    <p className="mt-4 max-w-md text-xs leading-relaxed text-cream/50">{t.footer.medicalNote}</p>
                </div>
                <nav aria-label={t.footer.quickLinks}>
                    <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-500">{t.footer.quickLinks}</h3>
                    <ul className="mt-5 space-y-3">
                        {t.nav.map((item) => (
                            <li key={item.id}>
                                <a
                                    href={`#${item.id}`}
                                    data-testid={`footer-link-${item.id}`}
                                    className="inline-flex min-h-[32px] items-center text-sm text-cream/80 transition-colors duration-300 hover:text-gold-500"
                                >
                                    {item.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
                <div>
                    <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-500">{t.footer.contactTitle}</h3>
                    <ul className="mt-5 space-y-4 text-sm text-cream/80">
                        <li className="flex items-start gap-3">
                            <IconPin className="mt-0.5 h-4 w-4 shrink-0 text-gold-500" />
                            <span>{t.contact.address}</span>
                        </li>
                        <li>
                            <a href={`tel:${PHONE_TEL}`} data-testid="footer-phone-link" className="flex min-h-[32px] items-center gap-3 transition-colors duration-300 hover:text-gold-500">
                                <IconPhone className="h-4 w-4 shrink-0 text-gold-500" />
                                <span dir="ltr">{PHONE_DISPLAY}</span>
                            </a>
                        </li>
                        <li>
                            <a
                                href={`https://wa.me/${WHATSAPP_NUMBER}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-whatsapp-link"
                                className="flex min-h-[32px] items-center gap-3 transition-colors duration-300 hover:text-gold-500"
                            >
                                <IconWhatsApp className="h-4 w-4 shrink-0 text-gold-500" />
                                <span dir="ltr">+962 79 591 4652</span>
                            </a>
                        </li>
                        <li>
                            <a
                                href={INSTAGRAM_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-instagram-link"
                                className="flex min-h-[32px] items-center gap-3 transition-colors duration-300 hover:text-gold-500"
                            >
                                <IconInstagram className="h-4 w-4 shrink-0 text-gold-500" />
                                {t.contact.instagramText}
                            </a>
                        </li>
                        <li>
                            <a
                                href={FACEBOOK_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-facebook-link"
                                className="flex min-h-[32px] items-center gap-3 transition-colors duration-300 hover:text-gold-500"
                            >
                                <IconFacebook className="h-4 w-4 shrink-0 text-gold-500" />
                                {t.contact.facebookText}
                            </a>
                        </li>
                        <li>
                            <a
                                href={`mailto:${EMAIL}`}
                                data-testid="footer-email-link"
                                className="flex min-h-[32px] items-center gap-3 transition-colors duration-300 hover:text-gold-500"
                            >
                                <IconMail className="h-4 w-4 shrink-0 text-gold-500" />
                                <span dir="ltr">{EMAIL}</span>
                            </a>
                        </li>
                    </ul>
                    <h3 className="mt-8 text-xs font-semibold uppercase tracking-[0.2em] text-gold-500">{t.footer.hoursTitle}</h3>
                    <p className="mt-4 text-sm text-cream/80">
                        {t.hours.women}: <span dir="ltr">{t.hours.womenTime}</span>
                    </p>
                    <p className="mt-2 text-sm text-cream/80">
                        {t.hours.men}: <span dir="ltr">{t.hours.menTime}</span>
                    </p>
                </div>
            </div>
            <div className="border-t border-cream/10">
                <div className="mx-auto max-w-7xl px-4 pb-24 pt-6 sm:px-6 md:pb-8 lg:px-8">
                    <p className="text-xs text-cream/60">
                        © {year} {t.footer.rights}
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default SiteFooter;
